import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const CustomersView = () => {
  const { data: id } = useParams();
  const navigate = useNavigate();

  const [rowData, setRowData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError("");

    fetch(`${process.env.REACT_APP_API_URL}/customers/${id}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQGF1dGhmYXN0LmNvbSIsImlkIjo1LCJ1c2VyVHlwZSI6InN1cGVyYWRtaW4iLCJpYXQiOjE2NjM2NTE2NzV9.raQf8JTVyiM51zg6OgH1RLkQqK_QyGPO2rJa9-oYDko",
      }),
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp?.data) setRowData(resp.data);
        else setError("Customer not found.");
      })
      .catch(() => setError("Failed to load customer details."))
      .finally(() => setLoading(false));
  }, [id]);

  const packageName =
    rowData?.package?.name ||
    (rowData?.package_id ? `#${rowData.package_id}` : "No package assigned");

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar: Back on left, title centered */}
      <div className="w-full bg-blue-600 text-white">
        <div className="relative max-w-5xl mx-auto px-4 py-3 flex items-center justify-center">
          <button
            onClick={() => navigate(-1)}
            className="absolute left-4 inline-flex items-center gap-2 rounded-md bg-white/10 hover:bg-white/20 px-3 py-1.5 text-sm font-medium"
            type="button"
          >
            ← Back
          </button>
          <h1 className="text-lg md:text-xl font-semibold">View Customer Details</h1>
        </div>
      </div>

      {/* Body */}
      <div className="max-w-5xl mx-auto px-4 py-10">
        {error ? (
          <div className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-red-700 text-sm">
            {error}
          </div>
        ) : loading ? (
          <div className="text-center text-gray-600">Loading customer details…</div>
        ) : (
          <div className="mx-auto w-full max-w-lg rounded-2xl bg-white shadow-md ring-1 ring-black/5">
            <div className="px-6 py-5 border-b">
              <h2 className="text-xl font-semibold text-gray-900">
                {rowData?.name || "Customer"}
              </h2>
              <p className="text-sm text-gray-500">ID: {rowData?.id ?? "-"}</p>
            </div>

            <div className="px-6 py-5 space-y-4">
              <div className="flex items-start justify-between gap-4">
                <span className="text-sm text-gray-600">Name</span>
                <span className="text-sm font-medium text-gray-900 max-w-[70%] text-right break-all">
                  {rowData?.name || "-"}
                </span>
              </div>

              <div className="flex items-start justify-between gap-4">
                <span className="text-sm text-gray-600">Domain</span>
                {rowData?.domain ? (
                  <a
                    href={rowData.domain}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-medium text-blue-600 hover:underline max-w-[70%] text-right break-all"
                  >
                    {rowData.domain}
                  </a>
                ) : (
                  <span className="text-sm font-medium text-gray-900">-</span>
                )}
              </div>

              <div className="flex items-start justify-between gap-4">
                <span className="text-sm text-gray-600">Redirect URL</span>
                {rowData?.redirect_url ? (
                  <a
                    href={rowData.redirect_url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-medium text-blue-600 hover:underline max-w-[70%] text-right break-all"
                  >
                    {rowData.redirect_url}
                  </a>
                ) : (
                  <span className="text-sm font-medium text-gray-900">-</span>
                )}
              </div>

              <div className="flex items-start justify-between gap-4">
                <span className="text-sm text-gray-600">Email</span>
                <span className="text-sm font-medium text-gray-900 max-w-[70%] text-right break-all">
                  {rowData?.email || "-"}
                </span>
              </div>

              <div className="flex items-start justify-between gap-4">
                <span className="text-sm text-gray-600">Package</span>
                <span className="text-sm font-medium text-gray-900 max-w-[70%] text-right break-all">
                  {packageName}
                </span>
              </div>

              <div className="pt-2 text-xs text-gray-500">
                {rowData?.createdAt && (
                  <div>Created: {new Date(rowData.createdAt).toLocaleString()}</div>
                )}
                {rowData?.updatedAt && (
                  <div>Updated: {new Date(rowData.updatedAt).toLocaleString()}</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomersView;
